<template>
    <div class="customFormStyle">
        <div class="resetFormIcon hoverActiveStyle" @click="resetForm()"><span class="iconfont icon-a-Group38206"></span></div>
        <slot name="customForm"></slot>
    </div>
</template>

<script>
export default {
    methods: {
        resetForm() {
            this.$nextTick(()=>{
                this.$children[0].resetFields();

            })
        }
    }

}
</script>

<style lang="less" scoped></style>